import React, { useEffect, useState } from 'react';
import { catalogApi } from '../lib/api';
import { FileCheck2 } from 'lucide-react';
import { PUBLICATION_STATUS_LABEL, t } from '../lib/catalogI18n';

export default function MyPublications() {
  const [pubs, setPubs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    catalogApi.myPublications().then(r => setPubs(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div className="p-6 space-y-4" data-testid="my-publications-page">
      <h1 className="text-3xl font-bold">Mis publicaciones</h1>
      <p className="text-gray-600">Aportaciones de datos publicadas por su empresa.</p>
      {loading ? <div>Cargando…</div> : pubs.length === 0 ? (
        <div className="text-center py-16 text-gray-500">Aún no ha publicado ninguna aportación.</div>
      ) : (
        <div className="bg-white rounded-lg border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600">
              <tr>
                <th className="px-3 py-2 text-left">Código</th>
                <th className="px-3 py-2 text-left">Producto</th>
                <th className="px-3 py-2 text-left">Campaña</th>
                <th className="px-3 py-2 text-left">Fecha</th>
                <th className="px-3 py-2 text-left">Estado</th>
                <th className="px-3 py-2 text-left">Versión condiciones</th>
                <th className="px-3 py-2 text-left">Huella SHA-256</th>
              </tr>
            </thead>
            <tbody>
              {pubs.map(p => (
                <tr key={p.id} className="border-t" data-testid={`pub-row-${p.publication_code}`}>
                  <td className="px-3 py-2 font-mono">{p.publication_code}</td>
                  <td className="px-3 py-2">{p.product_id.slice(0, 8)}…</td>
                  <td className="px-3 py-2">{p.campaign_id.slice(0, 8)}…</td>
                  <td className="px-3 py-2">{new Date(p.published_at).toLocaleString()}</td>
                  <td className="px-3 py-2">
                    <span className="inline-flex items-center gap-1 bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded-full text-xs">
                      <FileCheck2 className="w-3 h-3" /> {t(PUBLICATION_STATUS_LABEL, p.status)}
                    </span>
                  </td>
                  <td className="px-3 py-2">{p.terms_version}</td>
                  <td className="px-3 py-2 font-mono text-xs" title={p.file_hash}>{p.file_hash.slice(0, 16)}…</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
